const state = {
  //正在加载的数量
  loadingCounter: 0,
  // //首页Sider是否收起
  // siderCollapsed: false,
  //登录帐号信息
  userInfo: null,
  areaOrgs: null,//区域机构
  routers:[], //权限路径
  loginBy: null, //通过哪个登陆界面进入系统：1-通用；2-昆明；3-南海妇幼
  userSetting: [], //用户系统参数配置
}
export default state;



// WEBPACK FOOTER //
// ./src/store/rootState.js